export const arrayChunk = {
  methods: {
    arrayChunk (array, chunkSize) {
      return Array(Math.ceil(array.length / chunkSize)).fill().map((_, index) => index * chunkSize).map(begin => array.slice(begin, begin + chunkSize))
    }
  }
}
